import { render } from "./ConfirmationDialog.vue?vue&type=template&id=a9ce75dc&scoped=true&ts=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=a9ce75dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ce75dc"]])

export default __exports__